export enum SORT_OPTION {
  ASC = 'asc',
  DESC = 'desc'
}

export enum CHECKBOX {
  DEFAULT = 'checkbox',
  RADIO = 'radio'
}

export enum MOTIVATIONAL_SUMMARY_QUERY_PARAMS {
  DESKTOP = 'desktop',
  MOBILE = 'mobile'
}

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SYNC_STATUS {
  IDLE = 'idle',
  SYNCING = 'syncing'
}

/** Bucket for human-readable duration label selection (not a clock format). */
export enum DurationDisplayKind {
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  HOURS = 'hours',
  HOURS_MINUTES = 'hours_minutes'
}

export enum MOMENT_DURATION_UNIT {
  SECOND = 'second',
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day'
}

export enum FETCH_MODE {
  CORS = 'cors',
  NO_CORS = 'no-cors',
  SAME_ORIGIN = 'same-origin'
}

export enum DomEventType {
  CHANGE = 'change',
  MOUSE_DOWN = 'mousedown',
  KEY_DOWN = 'keydown',
  RESIZE = 'resize',
  SCROLL = 'scroll',
  BEFORE_UNLOAD = 'beforeunload',
  PAGE_SHOW = 'pageshow',
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export enum HTTP_METHOD {
  GET = 'get'
}
